<div class="header">
    <!-- <h2>NOTEBOOK</h2> -->
    <div class="logo-container">
    <img src="/assets/creator_logo.jpeg" class="logo-image">
    </div>
    <div class="mat-toggle">
        Dark mode
        <mat-slide-toggle
          class="example-margin"
          [color]="'black'"
          [checked]="false"
          [disabled]="false">
        </mat-slide-toggle>
    </div>
</div>